<template lang="pug">
  .lalamove
    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card.mt-6(v-else flat)
        v-card-title.text-center
          v-layout
            v-row.fill-height.ma-0( align='center' justify='center')
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/logo_lalamove.png')" style="width:240px" contain)
          v-layout.text-center.mt-10
            div.mx-auto
              h6.s1.text-center.default--text {{ currentTitle }}

        //-v-divider.mb-4
        v-window.pa-4(v-model='step')
          v-window-item(:value='1')
            v-form(ref="step1")
              .phone
                p.mb-2.label.basic600--text.text-uppercase {{$t('phone.label')}}
                v-text-field(v-model='form.phone'
                            solo flat outlined dense
                            background-color="basic200"
                            height="40"
                            type="tel"
                            :placeholder="$t('phone.placeholder')"
                            :prefix="form.phone? '' : '+6'"
                            :rules="rules.phone"
                            @keypress="isNumber($event)")
              .postcode
                p.mb-2.label.basic600--text.text-uppercase {{$t('shipment_postcode.label')}}
                v-text-field(v-model='shipmentPostcode'
                             solo flat outlined dense
                             background-color="basic200" height="40"
                             type="number"
                             :placeholder="$t('shipment_postcode.placeholder')"
                             :hint="$t('shipment_postcode.hint')"
                             :rules="rules.not_empty")
              .vehicle
                p.mb-1.label.basic600--text.text-uppercase Delivery service by
                v-radio-group(v-model="form.vehicle")
                  v-radio(:value='0' :label='`Motorcycle (Max load 36 x 36 x 36cm, 10kg)`')
                  v-radio(:value='1' :label='`Car (Max load 50 x 50 x 50cm, 40kg)`')

              .buffer
                p.mb-2.label.basic600--text.text-uppercase Add extra charge
                  v-slider.mt-14(v-model="form.buffer" color="grey darken-2" min="0" max="1000" step="50" thumb-label="always" :thumb-size="40")
                    template(v-slot:thumb-label="{ value }")
                      div.f1.white--text {{ $currency.symbol }} {{ value/this.$currency.multiplier}}

          v-window-item(:value='2')
            v-form(ref="step2")

              p.mb-2.label.basic600--text.text-uppercase {{$t('address_1.label')}}
              v-text-field(v-model="form.pickup_address.address_1"
                           solo flat outlined dense
                           background-color="basic200" height="40"
                           :placeholder="$t('address_1.placeholder')"
                           :rules="rules.not_empty")

              p.mb-2.label.basic600--text.text-uppercase {{$t('address_2.label')}}
              v-combobox(v-model="form.pickup_address.address_2"
                         solo flat outlined dense
                         background-color="basic200" height="40"
                         :placeholder="$t('address_2.placeholder')"
                         :rules="rules.not_empty"
                         :items="autofill_addresses")

              p.mb-2.label.basic600--text.text-uppercase {{$t('postcode.label')}}
              v-text-field(v-model="form.pickup_address.postcode"
                           solo flat outlined dense
                           background-color="basic200" height="40"
                           :placeholder="$t('postcode.placeholder')"
                           :rules="rules.not_empty"
                           readonly)
                v-icon(color="green lighten-1" slot="append") mdi-check-circle

              p.mb-2.label.basic600--text.text-uppercase {{$t('city.label')}}
              v-text-field(v-model="form.pickup_address.city"
                           solo flat outlined dense readonly
                           background-color="basic200" height="40"
                           :placeholder="$t('city.placeholder')"
                           :rules="rules.not_empty")
                v-icon(color="green lighten-1" slot="append") mdi-check-circle

              p.mb-2.label.basic600--text.text-uppercase {{$t('state.label')}}
              v-text-field(v-model="form.pickup_address.state"
                           solo flat outlined dense readonly
                           background-color="basic200" height="40"
                           :placeholder="$t('state.placeholder')"
                           :rules="rules.not_empty")
                v-icon(color="green lighten-1" slot="append") mdi-check-circle

              p.mb-2.label.basic600--text.text-uppercase {{$t('country.label')}}
              v-text-field(v-model="form.pickup_address.country"
                           solo flat outlined dense readonly
                           background-color="basic200" height="40"
                           :placeholder="$t('country.placeholder')"
                           :rules="rules.not_empty")
                v-icon(color="green lighten-1" slot="append") mdi-check-circle

          v-window-item(:value='3')
            v-form(ref="step3")
              div.p2.default--text Drag pinpoint icon 📍to adjust pickup location
              gmap-map(:zoom="16" 
                       :center="{lat:form.pickup_address.lat, lng:form.pickup_address.lng}" 
                       :options="{streetViewControl:false}" style="width:100%; height:400px;")
                gmap-marker(:draggable="true"
                            :position="{lat:form.pickup_address.lat, lng: form.pickup_address.lng}"
                            @dragend="updateCoordinate")
          v-window-item(:value='totalForms')
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                div.mt-1.p2.text-center.default--text You can now fulfill your deliveries with Lalamove

        //-v-divider
        v-card-actions.mr-4
          v-spacer
          v-btn(v-show='step > 1 && step < totalForms'
                text
                height="32"
                class="button-AA-medium"
                color='grey'
                @click='goBack()') Back
          v-btn(v-if='step === totalForms'
                depressed block
                class="button-AA-medium white--text"
                color="info500" height="32"
                @click="goHome()") Finish
          v-btn(v-else
                depressed
                class="button-AA-medium white--text"
                color="info500" height="32"
                :loading="isLoading"
                @click='clickNextButton()') Next
</template>

<script>
import Vue from "vue"
import { mapActions } from 'vuex'
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps,{
  load:{
      key: process.env.VUE_APP_GOOGLEMAP_API_KEY
      //libraries: 'places'
    },
    //installComponents: true
})

export default {
  name: 'SetupLalamove',
  props: ['company'],
  data () {
    return {
      step: 1,
      isFetching: false,
      totalForms: 4,
      form: {
        phone: null,
        vehicle: 0,
        buffer: 0,
        pickup_address: {
          address_1: '',
          address_2: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
          lat: 10,
          lng: 10
        }
      },
      shipmentPostcode: null,
      autofill_addresses: [], // Autofill address from postcode API
      isLoading: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        phone: [
          v => !!v || 'Phone Number is required',
          v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
        ],
      }
    }
  },
  computed: {
    currentTitle () {
      switch (this.step) {
        case 1: return 'Step 1: Account Informations'
        case 2: return 'Step 2: Fill in pickup address'
        case 3: return 'Step 3: Pickup location'
        default: return "You're all set"
      }
    },
    currentProgress () {
      return Math.floor((this.step.toFixed(2) / this.totalForms.toFixed(2)) * 100)
    },
    phoneSanitized () {
      let phone = this.form.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    fetchSettings () {
      this.isFetching = true
      // Fetch current Lalamove setting. Update local setting.
      this.$axios.get(`/shipping/settings/${this.company.slug}/lalamove`)
      .then((response) => {
          this.form = response.data
          if (this.form && this.form.pickup_address) {
            this.shipmentPostcode = this.form.pickup_address.postcode
          }
      })
      .catch(()=>{
        // Setting endpoint not yet exist. Use company postcode instead
        if (this.company.address) {
          this.shipmentPostcode = this.company.address.postcode
        }
      })
      .finally(()=>{
        this.isFetching = false
      })
    },
    goHome () {
      location.href = '/admin/settings/lalamove'
    },
    goBack () {
      this.step--
    },
    clickNextButton () {
      if (this.step === 1) {
        if (!this.$refs.step1.validate()) {
          return
        }
        if (this.shipmentPostcode == this.form.pickup_address.postcode) {
          this.step++
          return
        }
        
        this.isLoading = true
        this.$axios.get(`/shipping/postcodes?postcode=${this.shipmentPostcode}`).then((response) => {
          const resp_addresses = response.data
          // Set pickup address. Use first element from postcode API response
          if (resp_addresses.length > 0 && resp_addresses[0].postcode) {
            // Reset first and second address
            this.form.pickup_address.address_1 = ''
            this.form.pickup_address.address_2 = ''
            this.form.pickup_address.postcode = resp_addresses[0].postcode
            this.form.pickup_address.city = resp_addresses[0].city
            this.form.pickup_address.state = resp_addresses[0].state
            this.form.pickup_address.country = resp_addresses[0].country
            // Push addresses into autofill list
            resp_addresses.forEach(address => {
              this.autofill_addresses.push(address.address_2)
            })
            this.step++
          } else {
            this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      } else if (this.step === 2) {
        if (!this.$refs.step2.validate()) {
          return
        }
        this.form.phone = this.phoneSanitized
        this.isLoading = true
        this.axios.put(`/shipping/settings/${this.company.slug}/lalamove`, this.form)
        .then((response) => {
          this.form = response.data
          this.step++
        })
        .catch(() => {
          this.step--
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      }else if (this.step === 3){
        // Update adjusted geocoding
        this.isLoading = true
        this.axios.put(`/shipping/settings/${this.company.slug}/lalamove`, this.form)
        .then(() => {
          this.step++
        })
        .catch(() => {
          this.step--
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      }

    },
    updateCoordinate(location){
      this.form.pickup_address.lat = location.latLng.lat()
      this.form.pickup_address.lng = location.latLng.lng()
    }
  }
}
</script>

<i18n>
{
  "en": {
    "phone": {
      "label": "Phone No",
      "placeholder": "Write your phone number here"
    },
    "shipment_postcode": {
      "label": "Shipment's Postcode",
      "placeholder": "Write your shipment location's postcode here",
      "hint": "From where you usually post the item"
    },
    "shipment_address": {
      "label": "Shipment's Address",
      "placeholder": "Select your shipment location here "
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "ms": {
    "test": "Assalamualaikum"
  }
}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

